<template>
  <ul class="sumo-social-links">
    <li>
      <a
        class="sumo-link"
        href="https://www.youtube.com/channel/UCRrAZbOmqB3pX7dWHC_-wEQ"
        target="_blank"
        rel="noopener"
      >
        <YoutubeIcon />
        <span class="sr-only">Youtube</span>
      </a>
    </li>
    <li>
      <a
        class="sumo-link"
        href="https://www.facebook.com/appsumo/"
        target="_blank"
        rel="noopener"
      >
        <FacebookIcon />
        <span class="sr-only">Facebook</span>
      </a>
    </li>
    <li>
      <a
        class="sumo-link"
        href="https://www.instagram.com/appsumo/"
        target="_blank"
        rel="noopener"
      >
        <InstagramIcon />
        <span class="sr-only">Instagram</span>
      </a>
    </li>
    <li>
      <a
        class="sumo-link"
        href="https://twitter.com/AppSumo"
        target="_blank"
        rel="noopener"
      >
        <TwitterIcon />
        <span class="sr-only">Twitter</span>
      </a>
    </li>
    <li>
      <a
        class="sumo-link"
        href="https://www.tiktok.com/@appsumo"
        target="_blank"
        rel="noopener"
      >
        <TiktokIcon />
        <span class="sr-only">TikTok</span>
      </a>
    </li>
  </ul>
</template>

<script>
import FacebookIcon from '~/static/facebook-icon.svg?inline';
import InstagramIcon from '~/static/instagram-icon.svg?inline';
import TwitterIcon from '~/static/twitter-icon.svg?inline';
import YoutubeIcon from '~/static/youtube-icon.svg?inline';
import TiktokIcon from '~/static/tiktok-icon.svg?inline';

export default {
  components: {
    FacebookIcon,
    InstagramIcon,
    TiktokIcon,
    TwitterIcon,
    YoutubeIcon,
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.sumo-social-links {
  align-items: center;
  display: flex;
  list-style: none;
  gap: 0 2.5rem;
  padding: 0;
}

@include media-breakpoint-up(md) {
  .sumo-social-links {
    gap: 0 1.5rem;
  }
}
</style>
